class Events{

    handlers= {}
    lastId= 0
    
    constructor( events ){
        for( let e=0; e < events.length; e++) {
            this.handlers[ events[e] ]=[]
        }
    }

    getNewId(){ this.lastId++; return 'e'+ this.lastId }

/** ON: Da de alta un nuevo manejador
		event: Identificador del evento
		handler: Manejador del evento
		bind: Objeto que se cargará como this al ejecutar el manejador y se usa como filtro al lanzarlo
            Cuando se lanza el evento y existe un objeto como bind, solo se ejecutará el evento cuando el objeto es el mismo que esta en el bind.
*/
    on( event, handler, bind ){
        let entry= {event: event, handler: handler}
        let id;
        if ( typeof handler === 'function' && typeof this.handlers[ event ] === 'object' ){
                if ( typeof bind !== 'undefined' ) entry.bind= bind
                id= this.getNewId()
                this.handlers[ event ][ id ]= entry
                return id

        } else return false
    }

/** OFF: Da de baja un manejador registrado anteriormente
        event: Identificador del evento
        handlerId: Identificador del handler obtenido al ejecutar el on CUIDADO! No funciona si borramos y ponemos, porque no estamos dando identificador, sino cursor!!!!
*/
    off( event,  handlerId ){
        if ( typeof this.handlers[ event ][ handlerId ] === 'function' ) {
            delete (this.handlers[ event ][ handlerId ])
        }
    }

/** FIRES
	Lanza los manejadores de un evento
        event: Identificador del evento a lanzar
        params: Parámetros de la llamada
        obj: Objeto que se toma como this para el handler del evento.
            Si el evento se ha configurado con un bind, y se define este campo, solo se lanza el handler si coninciden.
*/
    fires( event, params, obj ){
        if ( typeof params  === 'undefined' ) params=[]
        if ( !Array.isArray( params ) ) params= [ params ]

        let handlerIds= Object.keys( this.handlers[ event ] )
        for (let h=0; h < handlerIds.length ; h++ ) {
            let handler= this.handlers[ event ][ handlerIds[h] ].handler
            let bind= typeof this.handlers[ event ][ handlerIds[h] ].bind !== 'undefined' ? this.handlers[ event ][ handlerIds[h] ].bind : false

            if ( bind ){
                if ( obj ) { if ( bind === obj ) handler.apply( bind, params ) }
                //else { handler.apply( bind, params ) } // si tenemos bind solo se ejecuta con ese bind, sino actualizamos con parametros además de bind.

            } else {
                if ( obj ) { handler.apply( obj, params ) }
                else { handler( params ) }

            }
        }
    }

}

export default Events